import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";
import { Modules, RouteParamsTypes } from "../../../../../enums";

const Header: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToListClick = () => {
    navigate(Modules.reconciliation + RouteParamsTypes.managerStatement);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t("reconciliation.managerStatement.detail.pageTexts.header.title")}</h4>
        <p>{t("reconciliation.managerStatement.detail.pageTexts.header.subTitle")}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end gap-3">
        <Button
          className="btn btn-primary waves-effect waves-light"
          onClick={handleGoToListClick}
          text={t("reconciliation.managerStatement.detail.pageTexts.header.goToList")}
        />
      </div>
    </div>
  );
};

export default Header;
